import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

// Recurring task series actions (pause / resume / stop / projections). Contract: zofino-strapi/docs/tasks/05-recurring-tasks-design.md
export default class TaskSeries extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "task-series";
    static pluralName = "task-series";
    static displayName = "TaskSeries";

    constructor() {
        super(`${TaskSeries.kind}`, `${TaskSeries.singularName}`, `${TaskSeries.pluralName}`);
    }

    async pause(seriesId) {
        return await this.postAction(`/task-series/${seriesId}/pause`, {});
    }

    async resume(seriesId, mode = "schedule") {
        return await this.postAction(`/task-series/${seriesId}/resume`, {mode});
    }

    async stop(seriesId) {
        return await this.postAction(`/task-series/${seriesId}/stop`, {});
    }

    async projections(query = {}) {
        const qs = require("qs");
        return await this.action(qs.stringify(query, {encodeValuesOnly: true}), "/task-series/projections");
    }

    async materialize(seriesId, sequenceNumber) {
        return await this.postAction(`/task-series/${seriesId}/occurrences/${sequenceNumber}/materialize`, {});
    }
}
